import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

import { createVuetify } from "vuetify";
import { de } from "vuetify/locale";
import { VDateInput } from "vuetify/labs/VDateInput";

const myCustomTheme = {
  colors: {
    primary: "#0076e5",
    primaryLight: "#deeefb",

    dark: "#323232",

    grey: "#5f5f5f",
    greyLight: "#f3f5f7",

    error: "#FF5252",
    errorLight: "#FDECEA",

    info: "#2196F3",

    success: "#4CAF50",
    successLight: "#E6F7E7",

    warning: "#FB8C00",
  },
};

export default createVuetify({
  theme: {
    defaultTheme: "myCustomTheme",
    themes: {
      myCustomTheme,
    },
  },
  components: {
    VDateInput,
  },
  locale: {
    locale: "de",
    fallback: "en",
    messages: { de },
  },
});
